import { LanguageConst } from "../../../utils/resources/languageconst";

export class TextTransform
{
    static convertToCaptialize(text: string)
    {
        return text === undefined || text === null ? " " : text.split(' ').map((eachText: string) => 
            eachText.charAt(0).toUpperCase() + eachText.substr(1).toLowerCase()).join(' ');
    }

    static checkSearchedLanguage(searchKey: string, currentSelectedLanguage: string): string
    {
        if(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(searchKey))
        {
            return currentSelectedLanguage;
        }
        else if(/^[a-zA-Z0-9\s]+$/.test(searchKey))
        {
            return LanguageConst.ENGLISH;
        }
        else
        {
            return LanguageConst.BURMESE;
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/texttransform/texttransform.ts